import React, {ReactNode, useEffect, useState} from 'react';
import {DetailGrid, Utility, wdiCore} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, WdiModalAppResult, WdiModalProps} from '@/components/WdiControls';
import {Button, Dropdown, Menu, message, Space, Typography} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats'
import DataStore from '@/components/GridWidget/DataStore'
import {ResponseStatus} from '@/utils/request';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import FormSaDetailPrevApp from './DetailPrev';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {last} from 'lodash';
import {Enum} from '@/enums/system';
import {toExcel, ToExcelProps} from '@/components/WdiControls/WdiExcel';
import {GridApi} from '@/services/gridapi';
import FormSaDetailCompareModalApp from '../../components/FormSaDetailCompare';
import PdDiscountGtDetailApp from "@/pages/sales/sa/PriceDiscountApply/components/DetailEditPdDiscountGt";
import PdDiscountKaDetailApp from "@/pages/sales/sa/PriceDiscountApply/components/DetailEditPdDiscountKa";
import PdBuyGiveDetailApp from "@/pages/sales/sa/PriceDiscountApply/components/DetailEditPdBuyGive";
import {getProductSheet} from "@/pages/sales/sa/components/data";
import {WdiSelect} from "@/components/WdiControls/WdiSelect";
import {Product} from "@/services/mdm/product";

const ModalTypeEnums = {
  None: 0,
  Prev: -1,
  Import: -2,
  PD_DISCOUNT_KA: 401,
  PD_DISCOUNT_GT: 402,
  PD_BUY_GIVE: 411,
};

export type DetailForApplyProps = {
  data?: any,
  initDataSource?: any[],
  dataSource: any[],
  onChange?: (dataSource: any) => void;
};

// 拓展列
const initRowFieldConfigs = (record: any) => {
  return ["productBuyIds", "activityStartDate", "activityEndDate", "supplyStartDate", "supplyEndDate",
    "revenueType", "priceSellinBefore", "priceSellinAfter", "productFreeIds", "quantityBuy", "quantityFree", "amount",
    "ecId", "uomCode", "pricePosBefore", "quantityBomForecast", "quantitySellinForecast", "quantityMin", "revenueMin",
    "isLimited", "revenueSellinForecast", "grossRateFront", "roiForecast", "discountAmountSellin", "priceLimit",
    "productBuyCodes", "remark", "priceSellinBeforeMin", "priceSellinAfterMin", "priceLimitMin", "tpmDetailId",
    "quantitySellinActual", "revenueSellinActual", "roiActual", "syncStatus", "syncStatus1", "grossRate", "priceSellinAfterOriginal",
    "priceLimitBelowRate", "isChannelLimited", "channelLimitedDesc", "ip"];
};

export const FormSaDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  // Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  const {data, dataSource, onChange} = props;

  const onModalClose = () => {
    setModalProps({visible: false, title: "", type: ModalTypeEnums.None, id: null});
  };

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      const newDataSource = [...dataSource];
      const result = uploadResult?.data?.data;

      if (result && result.length > 0) {
        if (uploadResult?.data?.exProperty) {
          //是否清空
          onChange?.(DataStore.init(result));
        } else {
          onChange?.(DataStore.addMulti(newDataSource, result));
        }
      }
    }
    onModalClose();
  }

  const onPreFieldValidate = () => {
    if (!data?.formSa?.applyScopeId || !data?.formSa?.boIds || !data?.formSa?.custTypeId) {
      message.error("请先选择适用范围类型、使用部门、客户分类").then();
      return false;
    }
    return true;
  }

  const onPrevSave = (result?: WdiModalAppResult) => {
    const modalSetting: WdiModalProps = {
      visible: true,
      data: result?.data,
      type: result?.data.formSaDetail.revenueType
    };
    if (result?.data.rowIndex > -1) {
      setModalProps({title: "编辑费用明细", ...modalSetting});
    } else {
      setModalProps({title: "新建费用明细", ...modalSetting});
    }
  };

  const onEditSave = (result?: WdiModalAppResult) => {
    if (result && result.code === ResponseStatus.SUCCESS) {
      const row = result?.data;
      if (result?.data.rowIndex > -1) {
        const record = modalProps.data.row;
        const newItem = {...row};
        newItem.uid = record.uid;
        const newDataSource = DataStore.edit(dataSource, newItem);
        onChange?.(newDataSource);
      } else {
        const newItem = {...row};
        onChange?.(DataStore.add(dataSource, newItem));
      }
    }
    onModalClose();
  };

  useEffect(() => {
    const productSheet = getProductSheet();
    const importExcels = [
      {
        name: "全部下载",
        sheetProps: [productSheet]
      }, {
        name: "产品列表",
        sheetProps: [productSheet]
      }
    ];
    setImportExcels(importExcels);
  }, [props.data]);

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSADetailForPD', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields)
      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.productBuyIds.width = 240;
      settings.formSchema.allFields.productFreeIds.width = 240;
      settings.formSchema.allFields.priceSellinBefore.width = 155;
      settings.formSchema.allFields.priceLimit.width = 130;
      settings.formSchema.allFields.priceSellinAfter.width = 180;
      settings.formSchema.allFields.quantityBuy.width = 190;
      settings.formSchema.allFields.quantityFree.width = 190;
      settings.formSchema.allFields.quantityBomForecast.width = 125;
      settings.formSchema.allFields.priceLimitBelowRate.width = 125;
      settings.formSchema.allFields.quantitySellinForecast.width = 200;
      settings.formSchema.allFields.revenueSellinForecast.width = 150;
      settings.formSchema.allFields.revenueSellinForecast.aggr = TableColumnRanderFormats.sumAggr('revenueSellinForecast', 2);
      settings.formSchema.allFields.amount.width = 100;
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.quantityMin.width = 140;
      settings.formSchema.allFields.revenueMin.width = 140;
      settings.formSchema.allFields.isLimited.width = 100;
      settings.formSchema.allFields.discountAmountSellin.width = 150

      settings.formSchema.allFields.priceSellinBeforeMin.width = 140;
      settings.formSchema.allFields.priceLimitMin.width = 110;
      settings.formSchema.allFields.priceSellinAfterMin.width = 150;
      settings.formSchema.allFields.pricePosAfter.width = 150;
      settings.formSchema.allFields.productBuyCodes.width = 130;
      settings.formSchema.allFields.productBuyVCodes.width = 130;
      settings.formSchema.allFields.ecId.width = 130;


      Utility.setActionCallback(settings.formSchema.actions, 'Update',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          setModalProps({
            visible: true,
            title: '选择费用类型',
            type: ModalTypeEnums.Prev,
            id: record.formSaDetailId,
            data: {
              row: record,
              rows: context.dataSource,
              rowIndex: DataStore.getRowIndex(context.dataSource, record.uid),
              formSa: context.params.formSa,
            }
          });
        },
      );

      Utility.setActionCallback(settings.formSchema.actions, 'Copy',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          setModalProps({
            visible: true,
            title: '选择费用类型',
            type: ModalTypeEnums.Prev,
            id: record.formSaDetailId,
            data: {
              row: Object.assign({}, record, {formSaDetailIdOriginal: null}),
              rows: context.dataSource,
              rowIndex: -1,
              formSa: context.params.formSa,
            }
          });
        },
      );

      Utility.setActionCallback(settings.formSchema.actions, 'SystemDelete',
        async (grid: any, action: any, record: any) => {
          if (window.confirm("确定要删除吗？")) {
            const context = grid.getContext();
            onChange?.(DataStore.del(context.dataSource, record.uid));
            message.success("删除成功");
          }
        },
      );

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
      extra={
        <Dropdown.Button
          buttonsRender={(buttons: ReactNode[]) => {
            return [buttons[0], <Button type={"primary"} style={{width: 50, fontSize: 12}}>更多</Button>]
          }}
          type='primary'
          onClick={() => {
            if (!onPreFieldValidate()) {
              return;
            }
            const row: any = {};
            if (dataSource && dataSource.length > 0) {
              const lastRow = last(dataSource);
              row.ecId = lastRow.ecId;
              row.revenueType = data?.revenueType;
            }
            setModalProps({
              visible: true,
              title: '选择费用类型',
              type: ModalTypeEnums.Prev,
              id: null,
              data: {
                row: row,
                rows: dataSource,
                rowIndex: -1,
                formSa: data?.formSa,
              }
            });
          }}
          overlay={
            <Menu items={[
              data?.formSa.revenueType != Enum.RevenueType.BUY_GIVE ? {
                key: 'importDiscount',
                label: '特价明细导入',
                onClick: () => {
                  if (!onPreFieldValidate()) {
                    return;
                  }
                  setModalProps({
                    title: '特价明细导入',
                    visible: true,
                    type: ModalTypeEnums.Import,
                    data: {revenueType: data?.formSa.revenueType}
                  });
                }
              } : null,
              data?.formSa.revenueType == Enum.RevenueType.BUY_GIVE ? {
                key: 'importBuyGive',
                label: '搭赠明细导入',
                onClick: () => {
                  if (!onPreFieldValidate()) {
                    return;
                  }
                  setModalProps({
                    title: '搭赠明细导入',
                    visible: true,
                    type: ModalTypeEnums.Import,
                    data: {revenueType: data?.formSa.revenueType}
                  });
                }
              } : null
            ]}/>
          }
          style={{float: 'right'}}
        >
          新建
        </Dropdown.Button>
      }
    >
      {isLoaded && modalProps.visible && modalProps.type === ModalTypeEnums.Import && (
        <ImportModalApp
          title={modalProps.title}
          visible={modalProps.visible}
          settingsUrl="/expenseapi/saButtons/getImportSettings"
          uploadingUrl="/expenseapi/saButtons/importUploading"
          onClose={onModalClose}
          onSave={onImportSave}
          clientParameters={{
            formSa: data?.formSa,
            formSaDetails: JSON.stringify(dataSource),
          }}
          importExcels={importExcels}
        />)}
      {isLoaded && modalProps.visible && modalProps.type === ModalTypeEnums.Prev && (
        <FormSaDetailPrevApp {...modalProps} onClose={onModalClose} onSave={onPrevSave}/>
      )}
      {isLoaded && modalProps.visible && (modalProps.type === ModalTypeEnums.PD_DISCOUNT_KA) && (
        <PdDiscountKaDetailApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && modalProps.visible && (modalProps.type === ModalTypeEnums.PD_DISCOUNT_GT) && (
        <PdDiscountGtDetailApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && modalProps.visible && (modalProps.type === ModalTypeEnums.PD_BUY_GIVE) && (
        <PdBuyGiveDetailApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && (
        <DetailGrid {...pageGridSettings} params={data} autoColumn={['rowNumber']}/>
      )}
    </WdiPanel>
  );
};

type HeaderFilterType = {
  priceLimitBelowRate?: number,
  brandIds?: any[]
};

export const onDetailFilter = async (dataSource: any[]) => {
  return dataSource;
};

const onFilter = (filters: HeaderFilterType, dataSource: any[]) => {
  return dataSource.filter((item: any) => {
    let flag = true;
    if (!wdiCore.Object.IsNullOrUndefined(filters?.priceLimitBelowRate) && !(item.priceLimitBelowRate > Number(filters?.priceLimitBelowRate))) {
      flag = false;
    }
    if (filters?.brandIds && filters.brandIds.length > 0) {
      const idx = filters.brandIds?.findIndex(m => m == item.brandId);
      if (idx < 0) {
        flag = false;
      }
    }
    return flag;
  });
};

const DetailHeaderFilter: React.FC<{ dataSource: any[], onChange?: (dataSource: any[]) => void }> = (props) => {
  const [brandOpts, setBrandOpts] = useState<any[]>([]);
  const [filterOpts, setFilterOpts] = useState<HeaderFilterType>();

  useEffect(() => {
    (async () => {
      const productResp = await Product.searchAll({isActive: true, withPermissions: true, productLevels: "0,1"});
      const product1s = productResp.data.filter(item => item.productLevel !== Enum.ProductLevel.ROOT);
      setBrandOpts(product1s.map(item => ({label: item.codeOrName, value: item.productId,})));
    })()
  }, []);

  const handleFilterChange = (obj: any) => {
    setFilterOpts(Object.assign({}, filterOpts, obj));
  };

  return (
    <Space size={"large"}>
      <Space>
        <Typography.Text style={{color: 'var(--ant-primary-color)'}}>
          低于限价比例
        </Typography.Text>
        <WdiSelect {...{
          style: {width: '120px'},
          name: "priceLimitBelowRate",
          placeholder: "全部",
          options: [
            {value: 0.00, label: "低于0%"},
            {value: 0.03, label: "低于3%"},
            {value: 0.05, label: "低于5%"},
            {value: 0.10, label: "低于10%"}
          ],
          onChange: (value) => {
            handleFilterChange({priceLimitBelowRate: value});
          },
        }} />
      </Space>
      <Space>
        <Typography.Text style={{color: 'var(--ant-primary-color)'}}>
          品牌
        </Typography.Text>
        <WdiSelect {...{
          mode: 'multiple',
          style: {width: '200px'},
          name: "brandIds",
          placeholder: "请选择品牌",
          showSearch: true,
          value: filterOpts?.brandIds,
          options: brandOpts,
          onChange: (value) => {
            handleFilterChange({brandIds: value});
          }
        }} />
      </Space>
      <Button type='primary' onClick={(e) => {
        if (wdiCore.Object.IsNullOrUndefined(filterOpts)) {
          props?.onChange?.(props?.dataSource);
        } else {
          if (props && props.dataSource && filterOpts) {
            const details = onFilter(filterOpts, props.dataSource);
            props?.onChange?.(details);
          }
        }
      }}>
        查询
      </Button>
    </Space>
  );
};

export const FormSaDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSADetailForPDApproval', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.productBuyIds.width = 240;
      settings.formSchema.allFields.productFreeIds.width = 240;
      settings.formSchema.allFields.priceSellinBefore.width = 155;
      settings.formSchema.allFields.priceLimit.width = 130;
      settings.formSchema.allFields.priceSellinAfter.width = 180;
      settings.formSchema.allFields.quantityBuy.width = 190;
      settings.formSchema.allFields.quantityFree.width = 190;
      settings.formSchema.allFields.quantityBomForecast.width = 125;
      settings.formSchema.allFields.priceLimitBelowRate.width = 125;
      settings.formSchema.allFields.revenueSellinForecast.width = 150;
      settings.formSchema.allFields.revenueSellinForecast.aggr = TableColumnRanderFormats.sumAggr('revenueSellinForecast', 2);
      settings.formSchema.allFields.amount.width = 100;
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.quantitySellinForecast.width = 200
      settings.formSchema.allFields.priceSellinAfterOriginal.width = 200
      settings.formSchema.allFields.quantityMin.width = 140;
      settings.formSchema.allFields.revenueMin.width = 140;
      settings.formSchema.allFields.isLimited.width = 100;
      settings.formSchema.allFields.discountAmountSellin.width = 150

      settings.formSchema.allFields.priceSellinBeforeMin.width = 140;
      settings.formSchema.allFields.priceLimitMin.width = 110;
      settings.formSchema.allFields.priceSellinAfterMin.width = 150;
      settings.formSchema.allFields.pricePosAfter.width = 150;
      settings.formSchema.allFields.productBuyCodes.width = 130;
      settings.formSchema.allFields.productBuyVCodes.width = 130;
      settings.formSchema.allFields.ecId.width = 130;
      settings.formSchema.allFields.grossRateFront.width = 120
      settings.formSchema.allFields.grossRate.width = 120


      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const {dataSource, initDataSource, data} = props;

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  useEffect(() => {
    if (data?.form) {
      setModalProps(Object.assign({}, modalProps, {title: "费用明细变更对比", data: {form: data.form}}));
    }
  }, [data]);

  const exportDetails = () => {
    const columns = [
      {name: "brandCode", displayName: "品牌编号"},
      {name: "brandName", displayName: "品牌名称"},
      {name: "productBuyCodes", displayName: "购买产品编号"},
      {name: "productBuyNames", displayName: "购买产品"},
      {name: "productFreeCodes", displayName: "赠送产品编号"},
      {name: "productFreeNames", displayName: "赠送产品"},
      {name: "priceSellinBefore", displayName: "原供货价(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "priceLimit", displayName: "限价(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "priceSellinAfter", displayName: "促销供货价(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "priceLimitBelowRate", displayName: "低于限价比例", type: Enum.FieldType.NUMBER},
      {name: "supplyStartDate", displayName: "开始供货日期"},
      {name: "supplyEndDate", displayName: "截止供货日期"},
      {name: "roiForecast", displayName: "预计费比", type: Enum.FieldType.NUMBER},
      {name: "priceSellinBeforeMin", displayName: "原供货价(中包)", type: Enum.FieldType.NUMBER},
      {name: "priceLimitMin", displayName: "限价(中包)", type: Enum.FieldType.NUMBER},
      {name: "priceSellinAfterMin", displayName: "促销供货价(中包)", type: Enum.FieldType.NUMBER},
      {name: "pricePosAfter", displayName: "促销零售价(中包)", type: Enum.FieldType.NUMBER},
      {name: "grossRate", displayName: "毛利率(不含折旧)", type: Enum.FieldType.NUMBER},
      {name: "grossRateFront", displayName: "前台毛利率", type: Enum.FieldType.NUMBER},
      {name: "quantityMin", displayName: "起订量(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "revenueMin", displayName: "起订金额", type: Enum.FieldType.NUMBER},
      {name: "isLimited", displayName: "是否限量", type: Enum.FieldType.BOOLEAN},
      {name: "quantityBuy", displayName: "每套购买数量(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "quantityFree", displayName: "每套赠送数量(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "amount", displayName: "申请金额", type: Enum.FieldType.NUMBER},
      {name: "quantityBomForecast", displayName: "预计购买套数", type: Enum.FieldType.NUMBER},
      {name: "quantitySellinForecast", displayName: "预计出货销量(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "revenueSellinForecast", displayName: "预计出货销售额", type: Enum.FieldType.NUMBER},
      {name: "remark", displayName: "备注"},
      {name: "productBuyVCodes", displayName: "购买产品V码"},
      {name: "ecName", displayName: "费用项"},
      {name: "revenueTypeName", displayName: "核算类型"},
      {name: "discountAmountSellin", displayName: "价差(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "activityStartDate", displayName: "活动开始日期"},
      {name: "activityEndDate", displayName: "活动截止日期"},

      {name: "tpmDetailId", displayName: "活动明细编号"},
      {name: "quantitySellinActual", displayName: "实际出货销量(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "revenueSellinActual", displayName: "实际出货销售额", type: Enum.FieldType.NUMBER},
      {name: "roiActual", displayName: "实际费比", type: Enum.FieldType.NUMBER},
      {name: "syncStatusName", displayName: "同步状态"},
      {name: "syncStatus1Name", displayName: "同步状态(SFA)"},
      {name: "syncDate", displayName: "同步日期", type: Enum.FieldType.DATE_TIME},
      {name: "priceSellinAfterOriginal", displayName: "原促销供货价(箱/大袋)", type: Enum.FieldType.NUMBER},
      {name: "isChannelLimited", displayName: "渠道是否可卖", type: Enum.FieldType.BOOLEAN},
      {name: "channelLimitedDesc", displayName: "渠道限供错误描述"},
      {name: "ip", displayName: "IP"},
    ];
    const formSASheet = {
      data: initDataSource,
      names: columns,
      sheetName: "活动明细",
      cells: {
        activityStartDate: (_: any, row: any, value: any) => {
          if (value) {
            return wdiCore.Date.DateToString(row.activityStartDate);
          } else {
            return wdiCore.Date.DateToString(props?.data?.formSa?.activityStartDate);
          }
        },
        activityEndDate: (_: any, row: any, value: any) => {
          if (value) {
            return wdiCore.Date.DateToString(row.activityEndDate);
          } else {
            return wdiCore.Date.DateToString(props?.data?.formSa?.activityEndDate);
          }
        },
        supplyStartDate: (_: any, row: any, value: any) => {
          if (value) {
            return wdiCore.Date.DateToString(row.supplyStartDate);
          } else {
            return wdiCore.Date.DateToString(props?.data?.formSa?.supplyStartDate);
          }
        },
        supplyEndDate: (_: any, row: any, value: any) => {
          if (value) {
            return wdiCore.Date.DateToString(row.supplyEndDate);
          } else {
            return wdiCore.Date.DateToString(props?.data?.formSa?.supplyEndDate);
          }
        },
        grossRateFront: (_index: any, _row: any, value: any) => {
          return wdiCore.Number.RateToString(value);
        },
        grossRate: (_index: any, _row: any, value: any) => {
          return wdiCore.Number.RateToString(value);
        }
      }
    };
    toExcel({
      name: data?.form?.formNo + '_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
      sheetProps: [formSASheet]
    });
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>} collapsed={true}
      filter={
        <DetailHeaderFilter dataSource={initDataSource ?? []} onChange={props.onChange}/>
      }
      extra={
        <Space>
          <Button type='primary' onClick={(e) => {
            e.stopPropagation();
            exportDetails();
          }}>
            导出
          </Button>
        </Space>
      }>
      {isLoaded && modalProps.visible && (
        <FormSaDetailCompareModalApp {...modalProps} onClose={() => {
          setModalProps({...modalProps, ...{visible: false}});
        }}/>
      )}
      {isLoaded && (
        <DetailGrid {...pageGridSettings} />
      )}
    </WdiPanel>
  );
};
